export default __webpack_public_path__ + "static/1-37-0-cohorts-2-0-1b0b4889eafd43455da6ec605aedd727.png";